import { Navigate, createBrowserRouter } from 'react-router-dom';

import { AuthGate } from './auth/auth-gate.js';
import { AppShell } from './components/app-shell.js';
import { CypherConsole } from './pages/cypher-console.js';
import { GroupManager } from './pages/group-manager.js';
import { ImpactAnalyzer } from './pages/impact-analyzer.js';
import { RepoDetail } from './pages/repo-detail.js';
import { RepoList } from './pages/repo-list.js';
import { SymbolExplorer } from './pages/symbol-explorer.js';
import { WikiPage } from './pages/wiki-page.js';

export const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthGate>
        <AppShell />
      </AuthGate>
    ),
    children: [
      { index: true, element: <Navigate to="/repos" replace /> },
      { path: 'repos', element: <RepoList /> },
      { path: 'repos/:name', element: <RepoDetail /> },
      { path: 'repos/:name/explore', element: <SymbolExplorer /> },
      { path: 'repos/:name/impact', element: <ImpactAnalyzer /> },
      { path: 'repos/:name/cypher', element: <CypherConsole /> },
      { path: 'repos/:name/wiki', element: <WikiPage /> },
      { path: 'groups', element: <GroupManager /> },
    ],
  },
]);
